if (!customElements.get('stylish-outfit')) {
  const Base = customElements.get('stylish-looks');
  if (Base) customElements.define('stylish-outfit', class extends Base {
    connectedCallback() {
      if (this.ready) return;
      super.connectedCallback();
      this.forms=Array.from(this.querySelectorAll('form'));
      this.bundle=this.querySelector('.outfit__buy-both');
      this.bundle.addEventListener('click',()=>this.addBoth(),{signal:this.abort.signal});
      this.forms.forEach(form=>this.loadProduct(form,true));
      this.updateBundle();
    }
    choose(form) {
      super.choose(form);
      const product=form.product;
      const chosen=product?.variants.find(v=>String(v.id)===form.querySelector('select').value);
      const unavailable=product && (chosen?!chosen.available:!product.available);
      const article=form.closest('article');
      article.querySelector('.outfit__sold').hidden=!unavailable;
      const collection=article.querySelector('.outfit__collection');
      if(collection) collection.hidden=!unavailable;
      this.updateBundle();
    }
    async loadProduct(form,force=false) {
      if(this.bundle) this.bundle.disabled=true;
      await super.loadProduct(form,force);
      this.updateBundle();
    }
    selections() {return (this.forms || []).map(form=>({form,product:form.product,variant:form.product?.variants.find(v=>String(v.id)===form.querySelector('select').value)}));}
    updateBundle() {
      if(!this.bundle) return;
      const rows=this.selections();
      const ready=rows.length===2 && rows.every(r=>r.variant?.available && !r.form.loading && !r.product.requires_selling_plan);
      this.bundle.disabled=!ready || !!this.busyPair || rows.some(r=>r.form.busy);
      const onSale=rows.some(r=>r.variant?.compare_at_price>r.variant?.price);
      this.discountReady=this.dataset.discountEnabled==='true' && !!this.dataset.code && !onSale;
      this.querySelector('.outfit__terms').textContent=onSale?this.messages.incompatible:(this.discountReady?this.messages.discount_terms:this.messages.discount_pending);
      const total=rows.reduce((sum,r)=>sum+(r.variant?.price || 0),0);
      this.querySelector('.outfit__total').textContent=ready?`${this.messages.total}: ${this.money.format(total/100)}`:'';
    }
    async add(form) {if(this.busyPair)return;const pending=super.add(form);this.updateBundle();await pending;this.updateBundle();}
    async addBoth() {
      if(this.busyPair || this.bundle.disabled) return;
      const rows=this.selections();
      if(rows.length!==2 || rows.some(r=>!r.variant?.available)) return;
      const status=this.querySelector('.outfit__status');
      this.busyPair=true;this.updateBundle();
      this.forms.forEach(f=>{f.querySelector('select').disabled=true;f.querySelector('.stl__add').disabled=true;});
      status.textContent=this.messages.adding;
      let added=false;
      try {
        if(rows[0].product.id===rows[1].product.id) {const e=new Error(this.messages.same_product);e.confirmed=true;throw e;}
        const fresh=await Promise.all(rows.map(r=>{
          const url=new URL(r.form.dataset.url,location.origin);url.pathname+='.js';url.search='';return this.request(url.toString(),{cache:'no-store'});
        }));
        const variants=fresh.map((p,i)=>p.variants.find(v=>String(v.id)===String(rows[i].variant.id)));
        if(variants.some(v=>!v?.available)) {const e=new Error(this.messages.stock_error);e.confirmed=true;throw e;}
        const cartBefore=await this.request(this.root+'cart.js',{cache:'no-store'});
        const existingDiscount=cartBefore.total_discount>0 || cartBefore.discount_codes?.some(c=>c.applicable);
        const applyDiscount=this.discountReady && !variants.some(v=>v.compare_at_price>v.price) && !existingDiscount;
        const result=await this.request(this.root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:variants.map(v=>({id:Number(v.id),quantity:1}))})});
        if(result.items?.length!==2)throw Error(this.messages.uncertain);
        added=true;
        status.textContent=this.messages.pair_added;
        if(applyDiscount) {
          const existingCodes=(cartBefore.discount_codes || []).map(c=>c.code).filter(Boolean);
          const cart=await this.request(this.root+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({discount:[...existingCodes,this.dataset.code].join(',')})});
          const valid=cart.discount_codes?.some(c=>c.code.toLowerCase()===this.dataset.code.toLowerCase() && c.applicable);
          const discounted=variants.every(v=>cart.items.some(line=>line.variant_id===v.id && line.line_level_discount_allocations?.some(a=>a.discount_application?.title===this.dataset.code || a.discount_application?.type==='discount_code') && Math.abs(line.final_price-Math.round(v.price*.95))<=1));
          status.textContent=valid && discounted?this.messages.discount_added:this.messages.discount_unconfirmed;
        } else if(existingDiscount && this.discountReady) status.textContent=this.messages.pair_added+' '+this.messages.other_discounts;
        this.refreshCart();
      } catch(error) {status.textContent=added?this.messages.discount_unconfirmed:(error.confirmed?error.message:this.messages.uncertain);}
      finally {
        this.busyPair=false;
        this.forms.forEach(form=>{form.querySelector('select').disabled=false;this.choose(form);});
        this.updateBundle();
      }
    }
  });
}
